import type { ReactNode } from 'react'
import React from 'react'
import { type MatchProps } from '.'

export interface SwitchProps {
  fallback?: React.ReactNode | React.ReactNode[]
  children?: ReactNode
}
export const Switch: React.FC<SwitchProps> = (props) => {
  const children =
    React.Children.map(
      props.children,
      (child) =>
        child as React.ReactElement<React.PropsWithChildren<MatchProps>>
    ) ?? []
  const hasActiveChildren = !!children.filter((child) => !!child.props.when)
    .length
  return <>{hasActiveChildren ? props.children : props.fallback}</>
}

export default Switch
